import { logEntries$, logGroup } from '@mbrtargeting/metatag-shared-modules';
import { LogGroupOptions } from '@mbrtargeting/metatag-shared-types';

const logger = logGroup<LogGroupOptions>({ system: 'MetaTag', prefix: '' });

export { logger as log, logEntries$, logger };
